import React from 'react';
import { ApolloProvider, ApolloClient, InMemoryCache } from '@apollo/client';
import fetch from 'isomorphic-fetch';

export const client = new ApolloClient({
  fetch,
  uri: 'https://e2fkvn0d.api.sanity.io/v1/graphql/production/default',
  cache: new InMemoryCache(),
});

export const wrapRootElement = ({ element }) => {
  return <ApolloProvider client={client}>{element}</ApolloProvider>;
};
